import ISEP_LOGO from '../../assets/img/isep-logo.png';
import VGTU_LOGO from '../../assets/img/vgtu-logo.png';

const educationData = [
  {
    logo: VGTU_LOGO,
    title: 'BSc in Computer Engineering (Erasmus)',
    institution: 'Vilnius Gediminas Technical University, Lithuania',
    link: 'https://vilniustech.lt/index.php?lang=2',
    duration: '09/2018 - 01/2019',
  },
  {
    logo: ISEP_LOGO,
    title: "Bachelor's Degree in Informatics Engineering",
    institution: 'Polytechnic Institute of Porto, Portugal',
    link: 'https://www.isep.ipp.pt/',
    duration: '09/2014 - 09/2019',
  },
];

export default educationData;
